/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetResourceScheduleFutureActionsQuery,
  useGetResourceSchedulePastActionsQuery,
} from "~/generated/graphql";

type Props = {
  resourceId: string;
  futureLimit?: number;
  pastLimit?: number;
};

export function useGetResourceSchedule({
  resourceId,
  futureLimit = 100,
  pastLimit = 50,
}: Props) {
  const {
    data: futureData,
    loading: futureLoading,
    error: futureError,
  } = useGetResourceScheduleFutureActionsQuery({
    variables: {
      resourceId,
      page: 1,
      limit: futureLimit,
    },
    skip: !resourceId,
  });

  const {
    data: pastData,
    loading: pastLoading,
    error: pastError,
  } = useGetResourceSchedulePastActionsQuery({
    variables: {
      resourceId,
      page: 1,
      limit: pastLimit,
    },
    skip: !resourceId,
  });

  return {
    futureActions: futureData?.futureActionsForResource?.result ?? [],
    pastActions: pastData?.pastActionsForResource?.result ?? [],
    loading: futureLoading || pastLoading,
    error: futureError ?? pastError,
  } as const;
}
